import React, { useState, useEffect, useContext } from "react";
import jMoment from "moment-jalaali";
import Input from "../../../shared/components/Input";
import {
  VALIDATOR_REQUIRE,
  VALIDATOR_VALIDATED,
  VALIDATOR_AUTOCOMPLETE,
  VALIDATOR_DATE,
  VALIDATOR_SELECT,
} from "../../../shared/util/validators";
import useForm from "../../../shared/hooks/form-hooks";

import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";
import { useSnackbar } from "notistack";
import { AuthContext } from "../../../context/AuthContext";
import { CircularProgress, IconButton } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";

import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import axios from "axios";
import { baseUrl } from "../../../baseUrl";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const DoneSearchDoctors = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const auth = useContext(AuthContext);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [orderTypes, setOrderTypes] = useState([]);
  const [doctorNames, setDoctorNames] = useState([]);
  const [total, setTotal] = useState();
  const [done, setDone] = useState([]);
  const [updater, setUpdater] = useState(true);
  const [labs, setLabs] = useState([]);
  const [labNames, setLabNames] = useState([]);

  //expansion of additional fields
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const [formState, inputHandler] = useForm(
    {
      patientName: {
        value: "",
        isValid: true,
      },
      labName: {
        value: "",
        isValid: true,
      },
      boxNumber: {
        value: "",
        isValid: true,
      },
      orderType: {
        value: "",
        isValid: true,
      },
      startDate1: {
        value: "",
        isvalid: true,
      },
      startDate2: {
        value: "",
        isvalid: true,
      },
      lastExitDate1: {
        value: "",
        isvalid: true,
      },
      lastExitDate2: {
        value: "",
        isvalid: true,
      },
    },
    true
  );

  //order search handler
  async function sendRequest() {
    setIsLoading(true);
    axios
      .post(
        "/api/v1/doctors/search-order-doctor",
        {
          ...(formState.inputs.patientName.value && {
            patiantName: formState.inputs.patientName.value,
          }),
          ...(formState.inputs.labName.value.name && {
            laboratoryId: formState.inputs.labName.value.id, //the naming may change
          }),
          ...(formState.inputs.boxNumber.value && {
            boxNumber: formState.inputs.boxNumber.value,
          }),
          ...(formState.inputs.startDate1.value && {
            startDateStart: new Date(formState.inputs.startDate1.value)
              .getTime()
              .toString(),
          }),
          ...(formState.inputs.startDate2.value && {
            startDateEnd: new Date(formState.inputs.startDate2.value)
              .getTime()
              .toString(),
          }),
          ...(formState.inputs.lastExitDate1.value && {
            endDateInterval1: new Date(
              formState.inputs.lastExitDate1.value
            ).getTime(),
          }),
          ...(formState.inputs.lastExitDate2.value && {
            endDateInterval2: new Date(
              formState.inputs.lastExitDate2.value
            ).getTime(),
          }),
          page: props.page,
          status: 2,
          rowCount: props.rowCount,
        },
        {
          headers: {
            "Content-Type": "application/json",
            authorization: auth.token,
          },
        }
      )
      .then((response) => {
        setIsLoading(false);
        setDone([]);
        response.data.data.result.map((order) => {
          setDone((prevState) => [
            ...prevState,
            {
              id: order.id,
              boxNumber: order.boxNumber,
              patientName: order.patiantName,
              labName: order.doctorLab.laboratory.user.companyName,
              startDate: order.startDate,
              orderType: order.orderType.name,
              endDate: order.process.endDate,
            },
          ]);
        });
        setTotal(response.data.data.totalItem);
      })
      .catch((e) => {
        const messages = e.response.data.data;
        Array.isArray(messages)
          ? messages.map((message) => {
              enqueueSnackbar(message, { variant: "error" });
            })
          : enqueueSnackbar(messages, { variant: "error" });
        setIsLoading(false);
      });
  }
  //getting pageCount from total orders
  const pageCount = Math.ceil(total / props.rowCount);

  //inClinic search request
  useEffect(() => {
    sendRequest();
  }, [updater, props.page]);

  //sending the data to the parent component
  useEffect(() => {
    props.getOrderData(done, pageCount, labNames);
  }, [done]);

  //getting lab names
  useEffect(() => {
    async function sendRequest() {
      setLabs([]);
      setIsLoading(true);
      try {
        const response = await fetch(
          baseUrl + `/api/v1/doctors/get-laboratorys-doctor`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: auth.token,
            },
          }
        );
        const responseData = await response.json();
        if (!response.ok) {
          throw new Error(response.message);
        }
        setLabNames(
          responseData.data.map((lab) => {
            return { name: lab.name, id: lab.laboratory[0].id };
          })
        );
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        err.data &&
          err.data.map((error) => {
            enqueueSnackbar(error, { variant: "error" });
          });
      }
    }

    sendRequest();
  }, []);

  //test
  useEffect(() => {
    console.log(done);
  }, [done]);
  return (
    <React.Fragment>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          setUpdater(!updater);
        }}
      >
        <Grid container spacing={3}>
          <Grid md={4} xs={6}>
            <Input
              id="patientName"
              element="input"
              label="نام بیمار"
              validators={[VALIDATOR_VALIDATED()]}
              errorText="لطفا نام بیمار را وارد کنید."
              onInput={inputHandler}
              inputValid={true}
              size="small"
              variant="standard"
            />
          </Grid>
          <Grid md={4} xs={6}>
            <Input
              id="boxNumber"
              element="input"
              label="شماره جعبه"
              validators={[VALIDATOR_VALIDATED()]}
              errorText="لطفا شماره جعبه را وارد نمایید."
              onInput={inputHandler}
              inputValid={true}
              size="small"
              variant="standard"
            />
          </Grid>
          <Grid md={4} xs={6}>
            <Input
              id="labName"
              element="autoComplete"
              label="نام لابراتوار"
              validators={[VALIDATOR_AUTOCOMPLETE()]}
              errorText="لطفا نام لابراتوار را انتخاب کنید."
              onInput={inputHandler}
              options={labNames}
              getOptionLabel={(option) => option.name}
              inputValid={true}
              size="small"
              variant="standard"
            />
          </Grid>
          <Grid md={12} xs={12}>
            <ExpandMore
              expand={expanded}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
              <ExpandMoreIcon />
            </ExpandMore>
          </Grid>
          <Grid md={12}>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <Grid container spacing={3}>
                <Grid md={6} xs={12}>
                  <Grid md={12} sx={{ mb: 0, pb: 0 }}>
                    <Typography
                      variant="caption"
                      display="block"
                      gutterBottom
                      sx={{ mb: -1 }}
                    >
                      بازه شروع سفارش
                    </Typography>
                  </Grid>
                  <Grid md={12}>
                    <Input
                      id="startDate1"
                      element="datePick"
                      validators={[VALIDATOR_VALIDATED()]}
                      errorText="ورودی نامعتبر"
                      onInput={inputHandler}
                      inputValid={true}
                      disabled={false}
                      label="شروع"
                      disableFuture={true}
                      size="small"
                      variant="standard"
                    />
                  </Grid>
                  <Grid md={12}>
                    <Input
                      id="startDate2"
                      element="datePick"
                      validators={[VALIDATOR_VALIDATED()]}
                      errorText="ورودی نامعتبر"
                      onInput={inputHandler}
                      inputValid={true}
                      disabled={false}
                      label="پایان"
                      disableFuture={true}
                      size="small"
                      variant="standard"
                    />
                  </Grid>
                </Grid>
                <Grid md={6} xs={12}>
                  <Grid md={12} sx={{ mb: 0, pb: 0 }}>
                    <Typography
                      variant="caption"
                      display="block"
                      gutterBottom
                      sx={{ mb: -1 }}
                    >
                      بازه پایان سفارش
                    </Typography>
                  </Grid>
                  <Grid md={12}>
                    {" "}
                    <Input
                      id="lastExitDate1"
                      element="datePick"
                      validators={[VALIDATOR_VALIDATED()]}
                      errorText="ورودی نامعتبر"
                      onInput={inputHandler}
                      inputValid={true}
                      disabled={false}
                      label="شروع"
                      disableFuture={true}
                      size="small"
                      variant="standard"
                    />
                  </Grid>
                  <Grid md={12}>
                    <Input
                      id="lastExitDate2"
                      element="datePick"
                      validators={[VALIDATOR_VALIDATED()]}
                      errorText="ورودی نامعتبر"
                      onInput={inputHandler}
                      inputValid={true}
                      disabled={false}
                      label="پایان"
                      disableFuture={true}
                      size="small"
                      variant="standard"
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Collapse>
          </Grid>
          <Grid xs={12} sm={12}>
            <Button
              type="submit"
              // disabled={!formState.isValid}
              fullWidth
              color="secondary"
              variant="outlined"
              size="small"
            >
              جستجو
            </Button>
          </Grid>
        </Grid>
      </form>
    </React.Fragment>
  );
};

export default DoneSearchDoctors;
